module.exports = __webpack_public_path__ + "static/media/onboarding-push.700e3117.mp4";